import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import type { AdminProductVariant } from '../lib/admin-product';
import { ADMIN_PRODUCT } from '../lib/admin-product';

export function AppLayout({ product = ADMIN_PRODUCT }: { product?: AdminProductVariant }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-ops-bg">
      {mobileNavOpen ? (
        <button
          type="button"
          className="fixed inset-0 z-30 bg-black/30 lg:hidden"
          aria-label="Закрыть меню"
          onClick={() => setMobileNavOpen(false)}
        />
      ) : null}
      <Sidebar
        product={product}
        mobileOpen={mobileNavOpen}
        onNavigate={() => setMobileNavOpen(false)}
      />
      <div className="flex min-w-0 flex-1 flex-col lg:ml-0">
        <TopBar product={product} onMenuClick={() => setMobileNavOpen((v) => !v)} />
        <main className="flex-1 overflow-auto p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
